<template>
  <div class="editPrompt flex flex-col mt-4 mb-6">
    <div class="flex justify-between mb-4">
      <h1 class="text-left text-lg font-semibold text-primary-500">
        Task Details
      </h1>
    </div>
    <p class="text-left font-semibold">
      {{ task.description }}
    </p>
    <ul class="list-decimal my-2">
      <li
        v-for="procedurePart of procedureParts"
        :key="procedurePart"
        class="ml-4 text-left text-gray-800 dark:text-white/80"
      >
        {{ procedurePart }}
      </li>
    </ul>

    <section v-if="youtube_link" class="videoContainer relative h-0 my-4">
      <iframe
        :src="youtube_link"
        controls="1"
        frameborder="0"
        class="absolute top-0 left-0 w-full h-full"
      />
    </section>
    <section class="w-full flex justify-center mt-6">
      <VButton
        label="Close"
        @click="closePrompt"
        size="sm"
        uppercase
        color="secondary"
        outlined
        class="w-full sm:w-1/2"
      />
    </section>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import VButton from "@/components/Buttons/Button/VButton.vue"

export default {
  components: {
    VButton
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      "getProceedArgs",
    ]),
    task() {
      return this.getProceedArgs?.task
    },
    procedureParts() {
      let procedure = this.task.details;
      if (!procedure) return null;

      return procedure
        .split(". ")
        .filter(part => part.length > 0)
        .map(part => {
          const trimmed = part.trim();

          const withoutPeriod =
            trimmed[trimmed.length - 1] === "."
              ? trimmed.slice(0, -1)
              : trimmed;

          return withoutPeriod.charAt(0).toUpperCase() + withoutPeriod.slice(1);
        });
    },
    youtube_link() {
      if (!(this.task.video_link)) return null
      let link = this.task.video_link
      let watch_code = ''
      let code_start = 0
      if (link.includes('videoseries')) {
        console.log('video series (playlist)')
        return link
      } else if (link.includes('v=')) {
        code_start = link.indexOf('v=') + 'v='.length
        watch_code = link.slice(code_start, code_start + 11)
      } else if (link.includes('embed/')){
        code_start = link.indexOf('embed/') + 'embed/'.length
        watch_code = link.slice(code_start, code_start + 11)
      } else if (link.includes('/v/')) {
        code_start = link.indexOf('/v/') + '/v/'.length
        watch_code = link.slice(code_start, code_start + 11)
      } else if (link.includes('https://youtu.be')) {
        code_start = link.indexOf('.be/') + '.be/'.length
        watch_code = link.slice(code_start, code_start + 11)
      }
      else {
        console.warning('unsupported video link')
        return null
      }

      return `https://www.youtube.com/embed/${watch_code}`

    }
  },
  methods: {
    ...mapMutations([
      "setProceedArgs",
      "closePrompt",
      "proceedPrompt",
    ]),
  },
}
</script>

<style scoped>
.editPrompt {
  min-width: 18rem;
  max-width: 28rem;
  max-height: 80vh;
}
.videoContainer {
  /* Maintains 16:9 aspect ratio */
  padding-bottom: 56.25%;
}
</style>